import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {InquirySelectorSimpleComponent} from './inquiry-selector-simple.component';
import {SharedComponentsModule} from '../../../bonding_shared/components/shared-components.module';

import {CompanySharedModule} from '../../company/components/shared/company-shared.module';
import {PolicyContractSharedModule} from '../../policy/components/shared/policy-contract-shared.module';
import {OfferCountriesSumComponent} from './offer-countries-sum.component';
import {TabViewModule} from 'primeng/tabview';
import {OfferDecisionsComponent} from './offer-decisions.component';

import {InquiryLimitsComponent} from './inquiry-limits.component';
import {InquirySubinsuredsListComponent} from './inquiry-subinsureds-list.component';
import {OfferHistoryComponent} from './offer-history.component';
import {InquiryLifecycleDropdownComponent} from './inquiry-lifecycle-dropdown.component';
import {InquiryNewLimitDropdownComponent} from './inquiry-new-limit-dropdown.component';
import {OfferSelectorSectionComponent} from '../forms/sections/offer-selector-section.component';
import {InquiryBalancesComponent} from './inquiry-balances.component';

@NgModule({
  imports: [
    RouterModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    CompanySharedModule,
    PolicyContractSharedModule,
    TabViewModule,
  ],
  declarations: [
    InquirySelectorSimpleComponent,
    OfferDecisionsComponent,
    OfferCountriesSumComponent,
    InquiryLimitsComponent,
    OfferHistoryComponent,
    InquirySubinsuredsListComponent,
    InquiryLifecycleDropdownComponent,
    InquiryNewLimitDropdownComponent,
    OfferSelectorSectionComponent,
    InquiryBalancesComponent,
  ],
  exports: [
    InquirySelectorSimpleComponent,
    OfferCountriesSumComponent,
    InquiryLimitsComponent,
    InquirySubinsuredsListComponent,
    OfferDecisionsComponent,
    OfferHistoryComponent,
    InquiryLifecycleDropdownComponent,
    InquiryNewLimitDropdownComponent,
    OfferSelectorSectionComponent,
    InquiryBalancesComponent,
  ],
})
export class InquirySharedModule {}
